import CookieWarning from './CookieWarning';

export default CookieWarning;
